import { render, staticRenderFns } from "./detailHolev.vue?vue&type=template&id=7a6fb084&scoped=true"
import script from "./detailHolev.vue?vue&type=script&lang=js"
export * from "./detailHolev.vue?vue&type=script&lang=js"
import style0 from "./detailHolev.vue?vue&type=style&index=0&id=7a6fb084&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6fb084",
  null
  
)

export default component.exports